import Client from "../AxiosClient";
const resource = "/private/pays/";

export default {
  async get_pay(params) {
    try {
      const response = await Client.get(
        `${resource}get_pay?year=${params.year}&month=${params.month}&status=${params.status}&id=${params.id}&report_name=${params.report_name}&form_name=${params.form_name}&circulars_number=${params.circulars_number}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async get_pay_file(params) {
    try {
      const response = await Client.get(
        `${resource}get_pay_file?report_id=${params.report_id}&report_type=${params.report_type}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async get_statical_year(params) {
    try {
      const response = await Client.get(
        `${resource}get_statical_year?year=${params.year}&type=${params.type}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async insert_pay(body) {
    try {
      const response = await Client.post(`${resource}insert_pay`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_pay(body) {
    try {
      const response = await Client.post(`${resource}update_pay`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_pay_file(body) {
    try {
      const response = await Client.post(`${resource}update_pay_file`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_pay_status(body) {
    try {
      const response = await Client.post(`${resource}update_pay_status`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async delete_pay(body) {
    try {
      const response = await Client.post(`${resource}delete_pay`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  /**
   * Tải bản báo cáo thu ngân sách từ CSDL Tỉnh
   * @param {*} params {month, year}
   */
   async syncPayReport(params) {
    try {
      const {data} = await Client.get(`${resource}sync_pay_report`, {params});
      return data;
    } catch (error) {
      return {
        status: 'failed',
        data: [],
        message: error
      }
    }
  }
};
